import { IFormViewForm } from 'components/FormView';

const AuthorisationForm: IFormViewForm = {
  id: 'AuthorisationForm',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1,
        colspan: 3,
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true,
        elevation: 0,
      },
      children: [
        {
          id: 0,
          type: 'TYPOGRAPHY',
          props: {
            text: 'Authorisation is required. Please enter the authorisation details and select the Authorise button to proceed. If multiple authorisations are required, each authorisation must be entered separately.',
            type: 'custom',
          }
        },
        {
          id: 1,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Authorisation required',
            name: 'AuthorisationRequired',
            placeholder: '',
            size: 'small',
            disabled: true,
            required: false,
          }
        },
        {
          id: 2,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Authorisation pending',
            name: 'AuthorisationPending',
            placeholder: '',
            size: 'small',
            disabled: true,
            required: false,
          }
        },
        {
          id: 4,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'User ID',
            name: 'AuthUserId',
            size: 'small',
            lookupName: 'Personnel',
            isLookupTypeFixed: true,
            required: true,
          }
        },
        {
          id: 5,
          type: 'TEXT_FIELD',
          props: {
            label: 'PIN',
            name: 'AuthUserPin',
            placeholder: '****',
            size: 'small',
            type: 'password',
            required: false,
            autoComplete: 'off',
            inputProps: {
              maxLength: 4
            }
          }
        },
      ]
    }
  ]
};
export default AuthorisationForm;
